import React from 'react'
import { Link } from 'gatsby'
import HealthcareIMG from '../../assets/images/icons/pic1.png'
import AIAutomationIMG from '../../assets/images/icons/pic2.png'
import MobileAppDevelopmentIMG from '../../assets/images/icons/pic3.png'
import shape2 from '../../assets/images/services/service-shape2.png'

const WhatWeDo = () => {
    return (
        <div className="boxes-area what-we-do-area">
            <fieldset>
                <legend className="headerfield">
                    <h2>What We Do</h2>
                </legend>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-boxes-item">
                                <div className="icon">
                                    <img src={HealthcareIMG} alt="Healthcare Solutions" />
                                </div>
                                <h3>Healthcare Solutions</h3>
                                <p>
                                    Secure, reliable healthcare software that improves patient care and operational efficiency.
                                </p>
                                <div className="shape1">
                                    <img src={shape2} alt="shape" />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-boxes-item">
                                <div className="icon">
                                    <img src={AIAutomationIMG} alt="AI Automation" />
                                </div>
                                <h3>AI Automation</h3>
                                <p>
                                    Turn manual processes into intelligent workflows with AI that saves time and improves accuracy.
                                </p>
                                <div className="shape1">
                                    <img src={shape2} alt="shape" />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-sm-3 offset-md-3">
                            <div className="single-boxes-item">
                                <div className="icon">
                                    <img src={MobileAppDevelopmentIMG} alt="Mobile App Development" />
                                </div>
                                <h3>Mobile App Development</h3>
                                <p>
                                    Cross-platform mobile applications that deliver a consistent experience across iOS and Android.
                                </p>
                                <div className="shape1">
                                    <img src={shape2} alt="shape" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center what-we-do-btn">
                        <Link to="/contact" className="default-btn">
                            <i className="flaticon-right"></i>
                            Contact Us
                            <span></span>
                        </Link>
                    </div>
                </div>
            </fieldset>
        </div>
    )
}

export default WhatWeDo
